export default [
  {
    "id": "mat-enem-0645",
    "numero": 2145,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Para resolver o problema de abastecimento de \nágua foi decidida, numa reunião do condomínio, \na construção de uma nova cisterna. A cisterna \natual tem formato cilíndrico, com 3 m de altura e \n2 m de diâmetro, e estimou-se que a nova cis-\nterna deverá comportar 81 m3 de água, manten-\ndo o formato cilíndrico e a altura da atual. Após \na inauguração da nova cisterna a antiga será \ndesativada. Utilize 3,0 como aproximação para \n𝜋.  \n \nQual deve ser o aumento, em metros, no raio da \ncisterna para atingir o volume desejado? \n \nA) 0,5 \nB) 1,0 \nC) 2,0 \nD) 3,5 \nE) 8,0",
    "alternativas": {
      "E": "8,0",
      "B": "1,0",
      "C": "2,0",
      "D": "3,5"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 645,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0646",
    "numero": 2146,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma carga de 100 contêineres, idênticos ao \nmodelo apresentado na Figura 1, deverá ser \ndescarregada no porto de uma cidade. Para \nisso, uma área retangular de 10m por 32 m foi \ncedida para o empilhamento desses contêineres \n(Figura 2). \n \n \nFigura 1 \n \nFigura 2 \n \nDe acordo com as normas desse porto, os con-\ntêineres deverão ser empilhados de forma a não \nsobrarem espaços nem ultrapassarem a área \ndelimitada. \n \nApós o empilhamento total da carga e atenden-\ndo à norma do porto, a altura mínima a ser atin-\ngida por essa pilha de contêineres é: \n \nA) 12,5 m.  \nB) 17,5 m.  \nC) 25,0 m. \nD) 22,5 m.  \nE) 32,5 m.",
    "alternativas": {
      "C": "25,0 m.",
      "D": "22,5 m.",
      "E": "32,5 m.",
      "A": "12,5 m."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 646,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0647",
    "numero": 2147,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Para o modelo de um troféu foi escolhido um \npoliedro P, obtido a partir de cortes nos vértices \nde um cubo. Com um corte plano em cada um \ndos cantos do cubo, retira-se o canto, que é um \ntetraedro de arestas menores do que metade da \naresta do cubo. Cada face do poliedro P, então, \né pintada usando uma cor distinta das demais \nfaces. \n \nCom base nas informações, qual é a quantidade \nde cores que serão utilizadas na pintura das \nfaces do troféu? \n \nA) 6  \nB) 8  \nC) 14  \nD) 24  \nE) 30",
    "alternativas": {
      "A": "6",
      "B": "8",
      "C": "14",
      "E": "30"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 647,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0648",
    "numero": 2148,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma padaria vende, em média, 100 pães espe-\nciais por dia e arrecada com essas vendas, em \nmédia, R$ 300,00. Constatou-se que a quanti-\ndade de pães especiais vendidos diariamente \naumenta, caso o preço seja reduzido, de acordo \ncom a equação: \n \nq = 400 – 100p, \n \nNa qual q representa a quantidade de pães \nespeciais vendidos diariamente e p, o seu preço \nem reais. \n \nA fim de aumentar o fluxo de clientes, o gerente \nda padaria decidiu fazer uma promoção. Para \ntanto, modificará o preço do pão especial de \nmodo que a quantidade a ser vendida diaria-\nmente seja a maior possível, sem diminuir a \nmédia de arrecadação diária na venda desse \nproduto. \n \nO preço p, em reais, do pão especial nessa \npromoção deverá estar no intervalo: \n \nA) R$ 0,50 ≤ p < R$ 1,50 \nB) R$ 1,50 ≤ p < R$ 2,50 \nC) R$ 2,50 ≤ p < R$ 3,50 \nD) R$ 3,50 ≤ p < R$ 4,50 \nE) R$ 4,50 ≤ p < R$ 5,50",
    "alternativas": {
      "E": "R$ 4,50 ≤ p < R$ 5,50",
      "A": "R$ 0,50 ≤ p < R$ 1,50",
      "B": "R$ 1,50 ≤ p < R$ 2,50",
      "C": "R$ 2,50 ≤ p < R$ 3,50"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 648,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0649",
    "numero": 2149,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O HPV é uma doença sexualmente transmissí-\nvel. Uma vacina com eficácia de 98% foi criada \ncom o objetivo de prevenir a infecção por HPV \ne, dessa forma, reduzir o número de pessoas \nque venham a desenvolver câncer de colo de \nútero. Uma campanha de vacinação foi lançada \nem 2014 pelo SUS, para um público-alvo de \nmeninas de 11 a 13 anos de idade. Considera-\nse que, em uma população não vacinada, o \nHPV acomete 50% desse público ao longo de \nsuas vidas. Em certo município, a equipe coor-\ndenadora da campanha decidiu vacinar meninas \nentre 11 e 13 anos de idade em quantidade \nsuficiente para que a probabilidade de uma me-\nnina nessa faixa etária, escolhida ao acaso, vir a \ndesenvolver essa doença seja, no máximo, de \n5,9%. Houve cinco propostas de cobertura, de \nmodo a atingir essa meta: \n \nProposta I: vacinação de 90% do público-alvo. \n \nProposta 11: vacinação de 55,8% do público-\nalvo. \n \nProposta 111: vacinação de 88,2% do público-\nalvo. \n \nProposta IV: vacinação de 49% do público-alvo. \n \nProposta V: vacinação de 95,9% do público-\nalvo. \n \nPara diminuir os custos, a proposta escolhida \ndeveria ser também aquela que vacinasse a \nmenor quantidade possível de pessoas. \nA proposta implementada foi a de número: \n \nA) I.  \nB) II.  \nC) III.  \nD) IV.  \nE) V.",
    "alternativas": {
      "A": "I.",
      "B": "II.",
      "C": "III.",
      "D": "IV."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 649,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0650",
    "numero": 2150,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O acréscimo de tecnologias no sistema produti-\nvo industrial tem por objetivo reduzir custos e \naumentar a produtividade.  \n \nNo primeiro ano de funcionamento, uma indús-\ntria fabricou 8 000 unidades de um determinado \nproduto. No ano seguinte, investiu em tecnolo-\ngia adquirido novas máquinas e aumentou a \nprodução em 50%. Estima-se que esse aumen-\nto percentual se repita nos próximos anos, ga-\nrantindo um crescimento anual de 50%. Consi-\ndere P a quantidade anual de produtos fabrica-\ndos no ano t de funcionamento da indústria. \n \nSe a estimativa for alcançada, qual é a expres-\nsão que determina o número de unidades pro-\nduzidas P em função de t, para t ≥ 1? \n \nA) P(t) = 0,5 . t –1 + 8000 \nB) P(t) = 50 . t –1 + 8000 \nC) P(t) = 4000 . t –1 + 8000 \nD) P(t) = 8000 . (0,5)t–1 \nE) P(t) = 8000 . (1,5)t–1",
    "alternativas": {
      "D": "P(t) = 8000 . (0,5)t–1",
      "E": "P(t) = 8000 . (1,5)t–1",
      "B": "P(t) = 50 . t –1 + 8000",
      "C": "P(t) = 4000 . t –1 + 8000"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 650,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0651",
    "numero": 2151,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Para uma alimentação saudável, recomenda-se \ningerir, em relação ao total de calorias diárias, \n60% de carboidratos, 10% de proteínas e 30% \nde gorduras.  \n \nUma nutricionista, para melhorar a visualização \ndessas porcentagens, quer dispor esses dados \nem um polígono. Ela pode fazer isso em um \ntriângulo equilátero, um losango, um pentágono \nregular, um hexágono regular ou um octógono \nregular, desde que o polígono seja dividido em \nregiões cujas áreas sejam proporcionais às \nporcentagens mencionadas. Ela desenhou as \nseguintes figuras: \n \n \n \n \n \nEntre esses polígonos, o único que satisfaz as \ncondições necessárias para representar a in-\ngestão correta de diferentes tipos de alimentos \né o: \n \nA) triângulo.  \nB) losango. \nC) pentágono.  \nD) hexágono. \nE) octógono.",
    "alternativas": {
      "C": "pentágono.",
      "D": "hexágono.",
      "E": "octógono.",
      "A": "triângulo."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 651,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0653",
    "numero": 2153,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma empresa de telefonia celular possui duas \nantenas que serão substituídas por uma nova, \nmais potente. As áreas de cobertura das ante-\nnas que serão substituídas são círculos de raio \n2 km, cujas circunferências se tangenciam no \nponto O, como mostra a figura. \n \n \n \nO ponto O indica a posição da nova antena, e \nsua região de cobertura será um círculo cuja \ncircunferência tangenciará externamente as \ncircunferências das áreas de cobertura meno-\nres. \nCom a instalação da nova antena, a medida da \nárea de cobertura, em quilômetros quadrados, \nfoi ampliada em: \n \nA) 8𝜋. \nB) 12 𝜋. \nC) 16 𝜋. \nD) 32 𝜋. \nE) 64 𝜋.",
    "alternativas": {
      "A": "8𝜋.",
      "B": "12 𝜋.",
      "C": "16 𝜋.",
      "E": "64 𝜋."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 653,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0654",
    "numero": 2154,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Um casal realiza um financiamento imobiliário \nde R$ 180 000,00, a ser pago em 360 presta-\nções mensais, com taxa de juros efetiva de 1% \nao mês. A primeira prestação é paga um mês \napós a liberação dos recursos e o valor da pres-\ntação mensal é de R$ 500,00 mais juro de 1% \nsobre o saldo devedor (valor devido antes do \npagamento). Observe que, a cada pagamento, o \nsaldo devedor se reduz em R$ 500,00 e consi-\ndere que não há prestação em atraso. \n \nEfetuando o pagamento dessa forma, o valor, \nem reais, a ser pago ao banco na décima pres-\ntação é de: \n \nA) 2075,00. \nB) 2093,00. \nC) 2138,00. \nD) 2255,00. \nE) 2300,00.",
    "alternativas": {
      "C": "2138,00.",
      "D": "2255,00.",
      "A": "2075,00.",
      "B": "2093,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 654,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0655",
    "numero": 2155,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "As exportações de soja do Brasil totalizaram \n4,129 milhões de toneladas no mês de julho de \n2012, e registraram um aumento em relação ao \nmês de julho de 2011, embora tenha havido \numa baixa em relação ao mês de maio de 2012. \n \nA quantidade, em quilogramas, de soja exporta-\nda pelo Brasil no mês de julho de 2012 foi de: \n \nA) 4,129 x 103 \nB) 4,129 x 106 \nC) 4,129 x 109 \nD) 4,129 x 1012 \nE) 4,129 x 1015",
    "alternativas": {
      "C": "4,129 x 109",
      "D": "4,129 x 1012",
      "E": "4,129 x 1015",
      "B": "4,129 x 106"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 655,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0656",
    "numero": 2156,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "A expressão “Fórmula de Young” é utilizada \npara calcular a dose infantil de um medicamen-\nto, dada a dose do adulto: \nUma enfermeira deve administrar um medica-\nmento X a uma criança inconsciente, cuja dosa-\ngem de adulto é de 60 mg. A enfermeira não \nconsegue descobrir onde está registrada a ida-\nde da criança no prontuário, mas identifica que, \nalgumas horas antes, foi administrada a ela uma \ndose de 14 mg de um medicamento Y, cuja \ndosagem de adulto é 42 mg. Sabe-se que a \ndose da medicação Y administrada à criança \nestava correta. \n \nEntão, a enfermeira deverá ministrar uma dosa-\ngem do medicamento X, em miligramas, igual a: \n \nA) 15. \nB) 20. \nC) 30. \nD) 36. \nE) 40.",
    "alternativas": {
      "D": "36.",
      "E": "40.",
      "A": "15.",
      "B": "20."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 656,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0657",
    "numero": 2157,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Segundo dados apurados no Censo 2010, para \numa população de 101,8 milhões de brasileiros \ncom 10 anos ou mais de idade e que teve algum \ntipo de rendimento em 2010, a renda média \nmensal apurada foi de R$ 1202,00. A soma dos \nrendimentos mensais dos 10% mais pobres \ncorrespondeu a apenas 1,1 % do total de ren-\ndimentos dessa população considerada, en-\nquanto que a soma dos rendimentos mensais \ndos 10% mais ricos correspondeu a 44,5% des-\nse total. \n \nQual foi a diferença, em reais, entre a renda \nmédia mensal de um brasileiro que estava na \nfaixa dos 10% mais ricos e de um brasileiro que \nestava na faixa dos 10% mais pobres? \n \nA) 240,40 \nB) 548,11 \nC) 1723,67 \nD) 4026,70 \nE) 5216,68",
    "alternativas": {
      "B": "548,11",
      "D": "4026,70",
      "E": "5216,68",
      "A": "240,40"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 657,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0658",
    "numero": 2158,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Um pesquisador, ao explorar uma floresta, foto-\ngrafou uma caneta de 16,8 cm de comprimento \nao lado de uma pegada. O comprimento da \ncaneta (c), a largura (L) e o comprimento (C) da \npegada, na fotografia, estão indicados no es-\nquema anterior. \n \nA largura e o comprimento reais da pegada, em \ncentímetros, são, respectivamente, iguais a: \n \nA) 4,9 e 7,6. \nB) 8,6 e 9,8. \nC) 14,2 e 15,4. \nD) 26,4 e 40,8. \nE) 27,5 e 42,5.",
    "alternativas": {
      "C": "14,2 e 15,4.",
      "D": "26,4 e 40,8.",
      "A": "4,9 e 7,6.",
      "B": "8,6 e 9,8."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 658,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0659",
    "numero": 2159,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma indústria produz malhas de proteção solar \npara serem aplicadas em vidros, de modo a \ndiminuir a passagem de luz, a partir de fitas \nplásticas entrelaçadas perpendicularmente. Nas \ndireções vertical e horizontal, são aplicadas fitas \nde 1 milímetro de largura, tal que a distância \nentre elas é de (d – 1) milímetros, conforme a \nfigura. O material utilizado não permite a passa-\ngem da luz, ou seja, somente o raio de luz que \natingir as lacunas deixadas pelo entrelaçamento \nconsegue transpor essa proteção. \n \nA taxa de cobertura do vidro é o percentual da \nárea da região coberta pelas fitas da malha, que \nsão colocadas paralelamente às bordas do vi-\ndro. \n \n \n \nEssa indústria recebeu a encomenda de uma \nmalha de proteção solar para ser aplicada em \num vidro retangular de 5 m de largura por 9 m \nde comprimento. A medida de d, em milímetros, \npara que a taxa de cobertura da malha seja de \n75% é: \n \nA) 2  \nB) 1  \nC) 11/3 \nD) 4/3 \nE) 2/3",
    "alternativas": {
      "C": "11/3",
      "D": "4/3",
      "A": "2",
      "B": "1"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 659,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0660",
    "numero": 2160,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Um arquiteto está reformando uma casa. De \nmodo a contribuir com o meio ambiente, decide \nreaproveitar tábuas de madeira retiradas da \ncasa. Ele dispõe de 40 tábuas de 540 cm, 30 de \n810 cm e 10 de 1080 cm, todas de mesma lar-\ngura e espessura. Ele pediu a um carpinteiro \nque cortasse as tábuas em pedaços de mesmo \ncomprimento, sem deixar sobras, e de modo \nque as novas peças ficassem com o maior ta-\nmanho possível, mas de comprimento menor \nque 2 m. \n \nAtendendo ao pedido do arquiteto, o carpinteiro \ndeverá produzir: \n \nA) 105 peças. \nB) 120 peças. \nC) 210 peças. \nD) 243 peças. \nE) 420 peças.",
    "alternativas": {
      "B": "120 peças.",
      "C": "210 peças.",
      "D": "243 peças.",
      "E": "420 peças."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 660,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0661",
    "numero": 2161,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "A insulina é utilizada no tratamento de pacientes \ncom diabetes para o controle glicêmico. Para \nfacilitar sua aplicação, foi desenvolvida uma \n“caneta” na qual pode ser inserido um refil con-\ntendo 3 mL de insulina, como mostra a imagem. \n \n \nPara controle das aplicações, definiu-se a uni-\ndade de insulina como 0,01 mL. Antes de cada \naplicação, é necessário descartar 2 unidades de \ninsulina, de forma a retirar possíveis bolhas de \nar. \n \nA um paciente foram prescritas duas aplicações \ndiárias: 10 unidades de insulina pela manhã e \n10 à noite. Qual o número máximo de aplica-\nções por refil que o paciente poderá utilizar com \na dosagem prescrita? \n \nA) 25  \nB) 15  \nC) 13  \nD) 12  \nE) 8",
    "alternativas": {
      "A": "25",
      "C": "13",
      "D": "12",
      "E": "8"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 661,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0662",
    "numero": 2162,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma família composta por sete pessoas adul-\ntas, após decidir o itinerário de sua viagem, \nconsultou o site de uma empresa aérea e cons-\ntatou que o voo para a data escolhida estava \nquase lotado. Na figura, disponibilizada pelo \nsite, as poltronas ocupadas estão marcadas \ncom X e as únicas poltronas disponíveis são as \nmostradas em branco. \n \n \n \nO número de formas distintas de se acomodar a \nfamília nesse voo é calculado por: \n \nA) \n9!\n2! \n \nB) \n9!\n7! x 2!  \n \nC) 7! \n \nD) \n5!\n2! x 4! \n \nE) \n5!\n4! x \n4!\n3!",
    "alternativas": {
      "B": "9! 7! x 2!",
      "D": "5! 2! x 4!",
      "E": "5! 4! x 4! 3!",
      "A": "9! 2!"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 662,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0663",
    "numero": 2163,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O proprietário de um parque aquático deseja \nconstruir uma piscina em suas dependências. A \nfigura representa a vista superior dessa piscina, \nque é formada por três setores circulares idênti-\ncos, com ângulo central igual a 60°. O raio R \ndeve ser um número natural. \n \n \n \nO parque aquático já conta com uma piscina em \nformato retangular com dimensões 50 m x 24 m. \n \nO proprietário quer que a área ocupada pela \nnova piscina seja menor que a ocupada pela \npiscina já existente. \n \nConsidere 3,0 como aproximação para 𝜋. \nO maior valor possível para R, em metros, deve-\nrá ser: \n \nA) 16. \nB) 28. \nC) 29. \nD) 31. \nE) 49.",
    "alternativas": {
      "B": "28.",
      "C": "29.",
      "E": "49.",
      "A": "16."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 663,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0664",
    "numero": 2164,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Alguns exames médicos requerem uma inges-\ntão de água maior do que a habitual. Por reco-\nmendação médica, antes do horário do exame, \numa paciente deveria ingerir 1 copo de água de \n150 mililitros a cada meia hora, durante as 10 \nhoras que antecederiam um exame. A paciente \nfoi a um supermercado comprar água e verificou \nque havia garrafas dos seguintes tipos: \n \n \nGarrafa I: 0,15 litro \n \nGarrafa II: 0,30 litro \n \nGarrafa III: 0,75 litro \n \nGarrafa IV: 1,50 litro \n \nGarrafa V: 3,00 litros \n \nA paciente decidiu comprar duas garrafas do \nmesmo tipo, procurando atender à recomenda-\nção médica e, ainda, de modo a consumir todo \no líquido das duas garrafas antes do exame. \n \nQual o tipo de garrafa escolhida pela paciente? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "A": "I",
      "B": "II",
      "C": "III",
      "D": "IV"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 664,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0666",
    "numero": 2166,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Em uma escola, a probabilidade de um aluno \ncompreender e falar inglês é de 30%. Três alu-\nnos dessa escola, que estão em fase final de \nseleção de intercâmbio, aguardam, em uma \nsala, serem chamados para uma entrevista. \nMas, ao invés de chamá-los um a um, o entre-\nvistador entra na sala e faz, oralmente, uma \npergunta em inglês que pode ser respondida por \nqualquer um dos alunos. \n \nA probabilidade de o entrevistador ser entendido \ne ter sua pergunta oralmente respondida em \ninglês é: \n \nA) 23,7%  \nB) 30,0%  \nC) 44,1% \nD) 65,7%  \nE) 90,0%",
    "alternativas": {
      "E": "90,0%",
      "A": "23,7%",
      "C": "44,1%",
      "D": "65,7%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 666,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0667",
    "numero": 2167,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O polímero de PET (Politereftalato de Etileno) é um dos plásticos mais reciclados em todo o mundo de-\nvido à sua extensa gama de aplicações, entre elas, fibras têxteis, tapetes, embalagens, filmes e cordas. \nOs gráficos mostram o destino do PET reciclado no Brasil, sendo que, no ano de 2010, o total de PET \nreciclado foi de 282 kton (quilotoneladas). \n \n \n \nDe acordo com os gráficos, a quantidade de embalagens PET recicladas destinadas à produção de teci-\ndos e malhas, em kton, é mais aproximada de: \n \nA) 16,0.  \nB) 22,9.  \nC) 32,0. \nD) 84,6.  \nE) 106,6.",
    "alternativas": {
      "A": "16,0.",
      "B": "22,9.",
      "C": "32,0.",
      "E": "106,6."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 667,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0668",
    "numero": 2168,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Um concurso é composto por cinco etapas. \nCada etapa vale 100 pontos. A pontuação final \nde cada candidato é a média de suas notas nas \ncinco etapas. A classificação obedece à ordem \ndecrescente das pontuações finais. O critério de \ndesempate baseia-se na maior pontuação na \nquinta etapa. \n \n \n \nA ordem de classificação final desse concurso \né: \n \nA) A, B, C, E, D.  \nB) B, A, C, E, D. \nC) C, B, E, A, D.  \nD) C, B, E, D, A. \nE) E, C, D, B, A.",
    "alternativas": {
      "C": "C, B, E, A, D.",
      "E": "E, C, D, B, A.",
      "A": "A, B, C, E, D.",
      "B": "B, A, C, E, D."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 668,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0669",
    "numero": 2169,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O índice pluviométrico é utilizado para mensurar \na precipitação da água da chuva, em milímetros, \nem determinado período de tempo.  \n \nSeu cálculo é feito de acordo com o nível de \nágua da chuva acumulada em 1m2, ou seja, se \no índice for de 10 mm, significa que a altura do \nnível de água acumulada em um tanque aberto, \nem formato de um cubo com 1 m2 de área de \nbase, é de 10 mm. Em uma região, após um \nforte temporal, verificou-se que a quantidade de \nchuva acumulada em uma lata de formato cilín-\ndrico, com raio 300 mm e altura 1200 mm, era \nde um terço da sua capacidade. \n \nUtilize 3,0 como aproximação para 𝜋. \n \nO índice pluviométrico da região, durante o pe-\nríodo do temporal, em milímetros, é de: \n \nA) 10,8. \nB) 12,0. \nC) 32,4. \nD) 108,0. \nE) 324,0.",
    "alternativas": {
      "B": "12,0.",
      "C": "32,4.",
      "D": "108,0.",
      "A": "10,8."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 669,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0670",
    "numero": 2170,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Devido ao aumento do fluxo de passageiros, \numa empresa de transporte coletivo urbano está \nfazendo estudos para a implantação de um no-\nvo ponto de parada em uma determinada rota. A \nfigura mostra o percurso, indicado pelas setas, \nrealizado por um ônibus nessa rota e a localiza-\nção de dois de seus atuais pontos de parada, \nrepresentados por P e Q. \n \n \n \nOs estudos indicam que o novo ponto T deverá \nser instalado, nesse percurso, entre as paradas \njá existentes P e Q, de modo que as distâncias \npercorridas pelo ônibus entre os pontos P e T e \nentre os pontos T e Q sejam iguais. De acordo \ncom os dados, as coordenadas do novo ponto \nde parada são: \n \nA) (290; 20). \nB) (410;0). \nC) (410; 20). \nD) (440; 0). \nE) (440; 20).",
    "alternativas": {
      "D": "(440; 0).",
      "E": "(440; 20).",
      "B": "(410;0).",
      "C": "(410; 20)."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 670,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0671",
    "numero": 2171,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Deseja-se comprar lentes para óculos. As lentes \ndevem ter espessuras mais próximas possíveis \nda medida 3 mm. No estoque de uma loja, há \nlentes de espessuras: 3,10 mm; 3,021 mm; 2,96 \nmm; 2,099 mm e 3,07 mm. Se as lentes forem \nadquiridas nessa loja, a espessura escolhida \nserá, em milímetros, de: \n \nA) 2,099. \nB) 2,96. \nC) 3,021. \nD) 3,07. \nE) 3,10.",
    "alternativas": {
      "C": "3,021.",
      "D": "3,07.",
      "E": "3,10.",
      "A": "2,099."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 671,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0672",
    "numero": 2172,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Alguns medicamentos para felinos são adminis-\ntrados com base na superfície corporal do ani-\nmal. Foi receitado a um felino pesando 3,0 kg \num medicamento na dosagem diária de 250 mg \npor metro quadrado de superfície corporal. \nO quadro apresenta a relação entre a massa do \nfelino, em quilogramas, e a área de sua superfí-\ncie corporal, em metros quadrados. \n \n \n \nA dose diária, em miligramas, que esse felino \ndeverá receber é de: \n \nA) 0,624. \nB) 52,0. \nC) 156,0. \nD) 750,0. \nE) 1 201,9.",
    "alternativas": {
      "D": "750,0.",
      "E": "1 201,9.",
      "A": "0,624.",
      "B": "52,0."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 672,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0673",
    "numero": 2173,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Para economizar em suas contas mensais de \nágua, uma família de 10 pessoas deseja cons-\ntruir um reservatório para armazenar a água \ncaptada das chuvas, que tenha capacidade \nsuficiente para abastecer a família por 20 dias. \nCada pessoa da família consome, diariamente, \n0,08 m3 de água. \n \nPara que os objetivos da família sejam atingi-\ndos, a capacidade mínima, em litros, do reser-\nvatório a ser construído deve ser: \n \nA) 16.  \nB) 800.  \nC) 1600. \nD) 8000.  \nE) 16000.",
    "alternativas": {
      "B": "800.",
      "C": "1600.",
      "E": "16000.",
      "A": "16."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 673,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0674",
    "numero": 2174,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Segundo o Instituto Brasileiro de Geografia e \nEstatística (IBGE), produtos sazonais são aque-\nles que apresentam ciclos bem definidos de \nprodução, consumo e preço. Resumidamente, \nexistem épocas do ano em que a sua disponibi-\nlidade nos mercados varejistas ora é escassa, \ncom preços elevados, ora é abundante, com \npreços mais baixos, o que ocorre no mês de \nprodução máxima da safra. \n \nA partir de uma série histórica, observou-se que \no preço P, em reais, do quilograma de um certo \nproduto sazonal pode ser descrito pela função: \n \n \nOnde x representa o mês do ano, sendo x = 1 \nassociado ao mês de janeiro, x = 2 ao mês de \nfevereiro, e assim sucessivamente, até x = 12 \nassociado ao mês de dezembro. \n \nNa safra, o mês de produção máxima desse \nproduto é: \n \nA) janeiro. \nB) abril. \nC) junho. \nD) julho. \nE) outubro.",
    "alternativas": {
      "C": "junho.",
      "D": "julho.",
      "A": "janeiro.",
      "B": "abril."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 674,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0675",
    "numero": 2175,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma competição esportiva envolveu 20 equipes \ncom 10 atletas cada. Uma denúncia à organiza-\nção dizia que um dos atletas havia utilizado \nsubstância proibida. Os organizadores, então, \ndecidiram fazer um exame antidoping. Foram \npropostos três modos diferentes para escolher \nos atletas que irão realizá-lo: \n \nModo I: sortear três atletas dentre todos os \nparticipantes; \n \nModo II: sortear primeiro uma das equipes e, \ndesta, sortear três atletas; \n \nModo III: sortear primeiro três equipes e, então, \nsortear um atleta de cada uma dessas três \nequipes. \n \nConsidere que todos os atletas têm igual proba-\nbilidade de serem sorteados e que P(I), P(II) e \nP(III) sejam as probabilidades de o atleta que \nutilizou a substância proibida seja um dos esco-\nlhidos para o exame no caso do sorteio ser feito \npelo modo I, II ou III. \n \nComparando-se essas probabilidades, obtém-\nse: \n \nA) P(I) < P(III) < P(II)  \nB) P(II) < P(I) < P(III)  \nC) P(I) < P(II) = P(III)  \nD) P(I) = P(II) < P(III)  \nE) P(I) = P(II) = P(III)",
    "alternativas": {
      "E": "P(I) = P(II) = P(III)",
      "B": "P(II) < P(I) < P(III)",
      "C": "P(I) < P(II) = P(III)",
      "D": "P(I) = P(II) < P(III)"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 675,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0676",
    "numero": 2176,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Em uma confeitaria, um cliente comprou um \ncupcake (pequeno bolo no formato de um tronco \nde cone regular mais uma cobertura, geralmen-\nte composta por um creme), semelhante ao \napresentado na figura: \n \n \nComo o bolinho não seria consumido no estabe-\nlecimento, o vendedor verificou que as caixas \ndisponíveis para embalar o doce eram todas em \nformato de blocos retangulares, cujas medidas \nestão apresentadas no quadro: \n \n \n \nA embalagem mais apropriada para armazenar \no doce, de forma a não deformá-lo e com menor \ndesperdício de espaço na caixa, é: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "C": "III.",
      "D": "IV.",
      "E": "V.",
      "A": "I."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 676,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0677",
    "numero": 2177,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um granjeiro detectou uma infecção bacterioló-\ngica em sua criação de 100 coelhos. A massa \nde cada coelho era de, aproximadamente, 4 kg. \nUm veterinário prescreveu a aplicação de um \nantibiótico, vendido em frascos contendo 16 mL, \n25 mL, 100 mL, 400 mL ou 1 600 mL. A bula do \nantibiótico recomenda que, em aves e coelhos, \nseja administrada uma dose única de 0,25 mL \npara cada quilograma de massa do animal. \n \nPara que todos os coelhos recebessem a dosa-\ngem do antibiótico recomendada pela bula, de \ntal maneira que não sobrasse produto na emba-\nlagem, o criador deveria comprar um único fras-\nco com a quantidade, em mililitros, igual a: \n \nA) 16. \nB) 25. \nC) 100. \nD) 400. \nE) 1 600.",
    "alternativas": {
      "C": "100.",
      "E": "1 600.",
      "A": "16.",
      "B": "25."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 677,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0678",
    "numero": 2178,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Alguns brasileiros têm o hábito de trocar de \ncarro a cada um ou dois anos, mas essa prática \nnem sempre é um bom negócio, pois o veículo \ndesvaloriza com o uso. Esse fator é chamado \nde depreciação, sendo maior nos primeiros \nanos de uso. \n \nUma pessoa realizou uma pesquisa sobre o \nvalor de mercado dos dois veículos (X e Y) que \npossui. Colocou os resultados obtidos em um \nmesmo gráfico, pois os veículos foram compra-\ndos juntos. \n \n \n \nApós a pesquisa, ela decidiu vender os veículos \nno momento em que completarem quatro anos \nde uso. \n \nConsiderando somente os valores de compra e \nde venda dos veículos por essa pessoa, qual a \nperda, em reais, que ela terá? \n \nA) 10000,00 \nB) 15000,00 \nC) 25000,00 \nD) 35000,00 \nE) 45000,00",
    "alternativas": {
      "E": "45000,00",
      "A": "10000,00",
      "B": "15000,00",
      "C": "25000,00"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 678,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0679",
    "numero": 2179,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma pesquisa recente aponta que 8 em cada \n10 homens brasileiros dizem cuidar de sua be-\nleza, não apenas de sua higiene pessoal. \n \nOutra maneira de representar esse resultado é \nexibindo o valor percentual dos homens brasilei-\nros que dizem cuidar de sua beleza. \n \nQual é o valor percentual que faz essa repre-\nsentação? \n \nA) 80% \nB) 8% \nC) 0,8% \nD) 0,08% \nE) 0,008%",
    "alternativas": {
      "C": "0,8%",
      "D": "0,08%",
      "A": "80%",
      "B": "8%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 679,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0680",
    "numero": 2180,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Em uma pesquisa sobre prática de atividade \nfísica, foi perguntado aos entrevistados sobre o \nhábito de andar de bicicleta ao longo da semana \ne com que frequência o faziam. Entre eles, 75% \nafirmaram ter esse hábito, e a frequência sema-\nnal com que o faziam é a apresentada no gráfi-\nco: \n \n \n \nQue porcentagem do total de entrevistados re-\npresenta aqueles que afirmaram andar de bici-\ncleta pelo menos três vezes por semana? \n \nA) 70,0% \nB) 52,5% \nC) 22,5% \nD) 19,5% \nE) 5,0%",
    "alternativas": {
      "E": "5,0%",
      "B": "52,5%",
      "C": "22,5%",
      "D": "19,5%"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 680,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0681",
    "numero": 2181,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Doenças relacionadas ao saneamento ambien-\ntal inadequado (DRSAI) podem estar associa-\ndas ao abastecimento deficiente de água, tra-\ntamento inadequado de esgoto sanitário, con-\ntaminação por resíduos sólidos ou condições \nprecárias de moradia. O gráfico apresenta o \nnúmero de casos de duas DRSAI de uma cida-\nde: \nO mês em que se tem a maior diferença entre o \nnúmero de casos das doenças de tipo A e B é: \n \nA) janeiro. \nB) abril. \nC) julho. \nD) setembro. \nE) novembro.",
    "alternativas": {
      "D": "setembro.",
      "E": "novembro.",
      "A": "janeiro.",
      "C": "julho."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 681,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0682",
    "numero": 2182,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "No comércio é comumente utilizado o salário \nmensal comissionado. Além de um valor fixo, o \nvendedor tem um incentivo, geralmente um \npercentual sobre as vendas. Considere um ven-\ndedor que tenha salário comissionado, sendo \nsua comissão dada pelo percentual do total de \nvendas que realizar no período. O gráfico ex-\npressa o valor total de seu salário, em reais, em \nfunção do total de vendas realizadas, também \nem reais. \n \n \n \nQual o valor percentual da sua comissão? \n \nA) 2,0% \nB) 5,0% \nC) 16,7% \nD) 27,7% \nE) 50,0%",
    "alternativas": {
      "B": "5,0%",
      "D": "27,7%",
      "E": "50,0%",
      "A": "2,0%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 682,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0683",
    "numero": 2183,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "A figura anterior é uma representação simplifi-\ncada do carrossel de um parque de diversões, \nvisto de cima. Nessa representação, os cavalos \nestão identificados pelos pontos escuros, e ocu-\npam circunferências de raios 3 m e 4 m, respec-\ntivamente, ambas centradas no ponto O. Em \ncada sessão de funcionamento, o carrossel \nefetua 10 voltas. \n \nQuantos metros uma criança sentada no cavalo \nC1 percorrerá a mais do que uma criança no \ncavalo C2, em uma sessão? Use 3,0 como \naproximação para 𝜋. \n \nA) 55,5 \nB) 60,0 \nC) 175,5 \nD) 235,5 \nE) 240,0",
    "alternativas": {
      "B": "60,0",
      "C": "175,5",
      "E": "240,0",
      "A": "55,5"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 683,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0684",
    "numero": 2184,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O padrão internacional ISO 216 define os tama-\nnhos de papel utilizados em quase todos os \npaíses. O formato-base é uma folha retangular \nde papel chamada de A0, cujas dimensões es-\ntão na razão 1:√2 . A partir de então, dobra-se a \nfolha ao meio, sempre no lado maior, definindo \nos demais formatos, conforme o número da \ndobradura. Por exemplo, A1 é a folha A0 dobra-\nda ao meio uma vez, A2 é a folha A0 dobrada \nao meio duas vezes, e assim sucessivamente, \nconforme figura. \n \n \n \nUm tamanho de papel bastante comum em es-\ncritórios brasileiros é o A4, cujas dimensões são \n21,0 cm por 29,7 cm. \n \nQuais são as dimensões, em centímetros, da \nfolha A0? \n \nA) 21,0 x 118,8 \nB) 84,0 x 29,7 \nC) 84,0 x 118,8 \nD) 168,0 x 237,6 \nE) 336,0 x 475,2",
    "alternativas": {
      "B": "84,0 x 29,7",
      "C": "84,0 x 118,8",
      "D": "168,0 x 237,6",
      "A": "21,0 x 118,8"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 684,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0685",
    "numero": 2185,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma barraca de tiro ao alvo de um parque de \ndiversões dará um prêmio de R$ 20,00 ao parti-\ncipante, cada vez que ele acertar o alvo. Por \noutro lado, cada vez que ele errar o alvo, deverá \npagar R$ 10,00. Não há cobrança inicial para \nparticipar do jogo. Um participante deu 80 tiros \ne, ao final, recebeu R$100,00. \nQual foi o número de vezes que esse participan-\nte acertou o alvo? \n \nA) 30 \nB) 36 \nC) 50 \nD) 60 \nE) 64",
    "alternativas": {
      "A": "30",
      "C": "50",
      "D": "60",
      "E": "64"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 685,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0686",
    "numero": 2186,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "No próximo final de semana, um grupo de alu-\nnos participará de uma aula de campo. Em dias \nchuvosos, aulas de campo não podem ser reali-\nzadas. A ideia é que essa aula seja no sábado, \nmas, se estiver chovendo no sábado, a aula \nserá adiada para o domingo. Segundo a meteo-\nrologia, a probabilidade de chover no sábado é \nde 30% e a de chover no domingo é de 25%. \n \nA probabilidade de que a aula de campo ocorra \nno domingo é de: \n \nA) 5,0% \nB) 7,5% \nC) 22,5% \nD) 30,0% \nE) 75,0%",
    "alternativas": {
      "A": "5,0%",
      "C": "22,5%",
      "D": "30,0%",
      "E": "75,0%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 686,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];